import React, { useState } from 'react';

const WpChatbot_Faq = () => {
    const faqs = [
        {
            q: "What is a WhatsApp Chatbot?",
            a: "An automated assistant on the WhatsApp Business Platform that answers FAQs, captures leads, takes orders, sends updates, and hands over to a human when needed."
        },
        {
            q: "What do I need to get started?",
            a: "A WhatsApp Business Account, a fresh phone number (not on regular WhatsApp), Meta Business verification, and a chatbot provider/partner to configure flows and APIs."
        },
        {
            q: "Can the bot transfer chats to a human agent?",
            a: "Yes. You can set rules for seamless handover based on intent, keywords, or CSAT. Agents see full chat history and can reply from a shared inbox."
        },
        {
            q: "Does it support multiple languages?",
            a: "Yes. You can build flows and templates in multiple languages (e.g., English, Hindi, Bangla, Arabic). The bot can auto-detect user preference or offer a language menu."
        },
        {
            q: "How do message templates and approvals work?",
            a: "Proactive messages use pre-approved templates (HSMs). Submit templates with placeholders; once approved by Meta, you can send them in bulk or via automation."
        },
        {
            q: "Can I sell or collect payments inside WhatsApp?",
            a: "Yes. Use product catalogs, carts, coupons, and UPI/cards/wallet integrations. Send invoices, order status, and delivery updates directly in chat."
        },
        {
            q: "What integrations are available?",
            a: "CRMs (HubSpot, Zoho, Salesforce), payment gateways, ticketing tools, ERPs, and custom backends via APIs/webhooks. Sync contacts, deals, and events in real time."
        },
        {
            q: "Is it secure and compliant?",
            a: "Messages are end-to-end encrypted. We offer role-based access, audit logs, and data retention controls. Follow Meta/WhatsApp policies and local data laws."
        }
    ];


    const [openIndex, setOpenIndex] = useState(0); // first open by default

    const toggle = (i) => setOpenIndex((prev) => (prev === i ? -1 : i));

    return (
        <section
            className="py-5 position-relative mb-5"
            style={{
                overflow: 'hidden',
                marginTop: "70px"
            }}
        >
            {/* Styles for FAQ UI */}
            <style>{`
                .faq-card {
               background: linear-gradient(135deg, #dce7fa, #fefefe);
              border: 1px solid #dae6fc;
              border-radius: 12px;
              padding: 18px 20px;
              display: flex;
              justify-content: space-between;
             align-items: flex-start;
             gap: 16px;
             transition: box-shadow 220ms ease, transform 220ms ease, background 220ms ease;
             cursor: pointer;
             }
     
             .faq-q {
               margin: 0;
               font-family: Lato;
               font-size: 20px;
               font-weight: 600;
               color: #242121ff;
               line-height: 1.3;
             }
             .faq-a {
               margin: 8px 0 0 0;
               font-family: Lato;
               font-weight: 400;
               font-size: 1.12rem;
               color: #413e3eff;
               line-height: 1.2;
               overflow: hidden;
               max-height: 0;
               opacity: 0;
               transition: max-height 320ms ease, opacity 240ms ease, margin 240ms ease;
             }
             .faq-a.open {
               max-height: 220px; /* large enough for content */
               opacity: 1;
               margin-top: 10px;
             }
     
             /* Right circular arrow button (3D-ish) */
             
             .arrow-btn {
              flex: 0 0 auto;
              width: 26px;
              height: 26px;
              border-radius: 999px;
              display: grid;
              place-items: center;
              border: 2px solid #3b5c92; 
              background: radial-gradient(
                 120% 120% at 30% 20%,
                 #ffffff 0%,
                 #f8faff 60%,   
                 #edf3fa 100%  
             );
             box-shadow:
             inset 0 -2px 0 rgba(0, 0, 0, 0.05), 
             inset 0 1px 0 rgba(255, 255, 255, 0.8);
             transition: transform 180ms ease, box-shadow 180ms ease, background 180ms ease;
             }
     
             .arrow-icon {
               width: 16px;
               height: 16px;
               fill: #0F2B54; /* navy */
               transition: transform 220ms ease;
             }
             .arrow-rotated {
               transform: rotate(180deg); /* down ↔ up */
             }
     
             /* spacing between cards */
             .faq-gap { height: 16px; }
           `}</style>

            <div
                className="px-5 x-xxl-5 px-6 mx-auto position-relative mb-5"
                style={{ maxWidth: '74%', zIndex: 1 }}
            >
                {/* Heading */}
                <div className="mb-5">
                    <h2
                        style={{
                            fontSize: "2.5rem",
                            fontFamily: "Inter",
                            fontWeight: 700,
                            color: "#242121ff",
                            lineHeight: 1.2,
                        }}
                    >
                        Frequently ask questions
                    </h2>
                    <p
                        className="mt-2"
                        style={{
                            marginTop: -2,
                            color: "#413e3eff",
                            fontSize: "1.1rem",
                            fontFamily: "Poppins",
                            fontWeight: 300,
                            lineHeight: 1.2,
                        }}
                    >
                        Quick answers on <span style={{ color: "#054E91", fontWeight: 700 }}>Vertex</span>{" "}
                        <span
                            style={{
                                background: "linear-gradient(90deg, #1F88E5 0%, #6EC9FF 100%)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                display: "inline-block",
                                fontWeight: 700
                            }}
                        >
                            Suite's
                        </span> automation, templates, pricing and uses- so you can start fast.
                    </p>
                </div>

                {/* FAQ list */}
                <div>
                    {faqs.map((item, i) => {
                        const isOpen = openIndex === i;
                        return (
                            <div key={i}>
                                <div
                                    className="faq-card"
                                    onClick={() => toggle(i)}
                                    onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && toggle(i)}
                                    role="button"
                                    tabIndex={0}
                                    aria-expanded={isOpen}
                                >
                                    <div style={{ flex: 1 }}>
                                        <h5 className="faq-q">{item.q}</h5>
                                        <p className={`faq-a ${isOpen ? 'open' : ''}`}>{item.a}</p>
                                    </div>

                                    {/* Right circular arrow */}
                                    <div
                                        className="arrow-btn"
                                        aria-hidden="true"
                                    >
                                        {/* Down arrow SVG that rotates to up when open (gives the “3D” pop with shadows above) */}
                                        <svg
                                            viewBox="0 0 24 24"
                                            className={`arrow-icon ${isOpen ? 'arrow-rotated' : ''}`}
                                        >
                                            {/* simple chevron/triangle mix for a crisp “straight bottom arrow” look */}
                                            <path d="M12 16c-.3 0-.6-.1-.8-.3l-6-6a1.1 1.1 0 0 1 1.6-1.6L12 13.7l5.2-5.6a1.1 1.1 0 1 1 1.6 1.6l-6 6c-.2.2-.5.3-.8.3z" />
                                        </svg>
                                    </div>
                                </div>

                                {/* gap between cards */}
                                {i !== faqs.length - 1 && <div className="faq-gap" />}
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default WpChatbot_Faq